// extracted by mini-css-extract-plugin
export var o_destacado_video = "destacadoVideo-module--o_destacado_video--d6bef";
export var o_destacado_video__btn = "destacadoVideo-module--o_destacado_video__btn--e27f7";
export var o_destacado_video__container = "destacadoVideo-module--o_destacado_video__container--af4d2";
export var o_destacado_video__desc = "destacadoVideo-module--o_destacado_video__desc--8d0d3";
export var o_destacado_video__h2 = "destacadoVideo-module--o_destacado_video__h2--71a19";
export var o_destacado_video__img = "destacadoVideo-module--o_destacado_video__img--2634a";
export var o_destacado_video__spin = "destacadoVideo-module--o_destacado_video__spin--cb0f4";
export var rotation = "destacadoVideo-module--rotation--06cac";